export default __webpack_public_path__ + "static/file-1556991421 1-16276395e58dda5a65634d76ff12b58b.webp";